import React from 'react';
import FloatMarketAction from './float-market-action';
import SourcingAction from './sourcing-action';

import './index.scss';

// const AsyncExpress = loadable(() => import('@ali'))
export default function Actions(props) {
  if (props.productIsMarketGoods) {
    return <FloatMarketAction {...props} />;
  }
  return <SourcingAction {...props} />;
}
